import { render } from "./emailSettings.vue?vue&type=template&id=6a2c00bf&scoped=true"
import script from "./emailSettings.vue?vue&type=script&lang=js"
export * from "./emailSettings.vue?vue&type=script&lang=js"

import "./emailSettings.vue?vue&type=style&index=0&id=6a2c00bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2c00bf"]])

export default __exports__